if (!customElements.get("smooth-scroll-link")) {
  class SmoothScrollLink extends HTMLElement {
    constructor() {
      super();
      this.handleClick = this.handleClick.bind(this);
    }

    connectedCallback() {
      this.anchor = this.querySelector("a");
      if (!this.anchor) return;

      this.scrollToId = this.dataset.scrollTo || null;
      this.scrollToClass = this.dataset.scrollToClass || null;
      this.offset = parseInt(this.dataset.scrollOffset || "0", 10);
      this.duration = parseInt(this.dataset.scrollDuration || "500", 10);
      this.easing = this.dataset.scrollEasing || "easeInOutCubic";

      this.anchor.addEventListener("click", this.handleClick);
    }

    disconnectedCallback() {
      if (this.anchor) {
        this.anchor.removeEventListener("click", this.handleClick);
      }
    }

    handleClick(event) {
      event.preventDefault();

      if (!this.scrollToId && !this.scrollToClass) return;

      let targetElement;

      if (this.scrollToClass) {
        targetElement = document.querySelector(`.${this.scrollToClass}`);
        if (!targetElement) return;
      }

      if (this.scrollToId) {
        targetElement = document.getElementById(this.scrollToId);
        if (!targetElement) return;
      }

      const targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset - this.offset;
      this.smoothScrollTo(window.pageYOffset, targetPosition, this.duration, this.getEasingFunction(this.easing));
    }

    smoothScrollTo(start, end, duration, easingFunc) {
      const startTime = performance.now();

      const animateScroll = (currentTime) => {
        const elapsed = currentTime - startTime;
        const progress = Math.min(elapsed / duration, 1);
        const easedProgress = easingFunc(progress);
        window.scrollTo(0, start + (end - start) * easedProgress);

        if (elapsed < duration) {
          requestAnimationFrame(animateScroll);
        }
      };

      requestAnimationFrame(animateScroll);
    }

    getEasingFunction(name) {
      const easings = {
        linear: (t) => t,
        easeInOutCubic: (t) => (t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2),
        easeOutQuad: (t) => t * (2 - t),
        easeInQuad: (t) => t * t,
      };
      return easings[name] || easings.linear;
    }
  }

  customElements.define("smooth-scroll-link", SmoothScrollLink);
}
